import { render, staticRenderFns } from "./GTeacherEdit.vue?vue&type=template&id=583a169a&scoped=true&"
import script from "./GTeacherEdit.vue?vue&type=script&lang=ts&"
export * from "./GTeacherEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GTeacherEdit.vue?vue&type=style&index=0&id=583a169a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a169a",
  null
  
)

export default component.exports